<template>
  <v-dialog v-model="show" width="500" persistent>
    <v-card class="rounded-lg">
      <v-card-title color="primary" class="primary primary-title">
        <v-icon color="white darken-3">mdi-download</v-icon>
        <span class="white--text title pl-2"> Export Plot </span>
      </v-card-title>

      <v-card-text class="pt-4">
        <v-text-field
          ref="vtf"
          v-model="filenamePrefix"
          :rules="[() => !!filenamePrefix || 'Filename is required.']"
          label="Filename"
          text
          clearable
          class="mt-2"
        >
        </v-text-field>

        <v-radio-group v-model="fileFormat" label="File format:" row>
          <v-radio key="ff-png" label="PNG" value="png"></v-radio>
          <v-radio key="ff-svg" label="SVG" value="svg"></v-radio>
        </v-radio-group>

        <v-radio-group
          v-if="exportOptions.length > 0"
          v-model="exportOption"
          label="Export:"
          row
        >
          <v-radio
            v-for="(opt, opt_i) in exportOptions"
            :key="'opt-' + opt_i"
            :label="opt"
            :value="opt"
          ></v-radio>
        </v-radio-group>
      </v-card-text>

      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text color="red lighten-2" @click="close()">
          <v-icon left>close</v-icon> Cancel
        </v-btn>
        <v-btn color="primary" @click="exportPlot">Export</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    defaultFilenamePrefix: {
      type: String,
      required: false,
      default: 'export',
    },
    exportOptions: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data() {
    return {
      filenamePrefix: null,
      fileFormat: 'png',
      exportOption: null,
    };
  },
  watch: {
    defaultFilenamePrefix(dfp) {
      this.filenamePrefix = dfp;
    },
  },
  mounted() {
    this.filenamePrefix = this.defaultFilenamePrefix;
    if (this.exportOptions.length > 0) {
      this.exportOption = this.exportOptions[0];
    }
  },
  methods: {
    close() {
      this.$emit('dialogClosed');
    },
    exportPlot() {
      this.$emit('exportPlot', {
        format: this.fileFormat,
        prefix: this.filenamePrefix,
        option: this.exportOption,
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
